import { automaticPublication } from 'api';
import {
  FETCH_PUBLICATIONS,
  UPDATE_PUBLICATIONS,
  PROCESS_FILE_OFFERS,
  UPDATE_OFFERS_FOR_PUBLISH,
  GET_MASTERDATA_MASIVE,
  SET_MASTERDATA_MASIVE,
  PUBLISH_OFFERS_MASIVE,
  GET_PUBLICATION_DETAIL,
  SET_PUBLICATION_DETAIL,
  GET_IMAGES_VEHICLE_ID
} from 'store/actions/automaticPublication';
import { paginationData } from 'helpers/store';

export default {
  [FETCH_PUBLICATIONS]: ({ commit }, { pagination, filters }) =>
    new Promise((resolve, reject) => {
      const limit = pagination.perPage;
      const offset = limit * (pagination.currentPage - 1);
      automaticPublication
        .getPublications({
          pagination: {
            limit,
            offset,
            sort: pagination.sortBy,
            sortType: pagination.sortDesc ? 'DESC' : 'ASC'
          },
          filters
        })
        .then(
          resp => {
            const data = resp.data || [];
            commit(UPDATE_PUBLICATIONS, data);
            resolve(paginationData(resp).total);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [PROCESS_FILE_OFFERS]: ({ commit }, file) =>
    new Promise((resolve, reject) => {
      const user = 'user';
      const description = 'description';
      const fileString = file[0].split('base64,')[1];
      automaticPublication
        .processFileOffers({
          user,
          description,
          fileString
        })
        .then(
          resp => {
            const data = resp.data || [];
            commit(UPDATE_OFFERS_FOR_PUBLISH, data);
            resolve();
          },
          err => {
            reject(err.response.data);
          }
        );
    }),

  [GET_MASTERDATA_MASIVE]: ({ commit }) =>
    new Promise((resolve, reject) => {
      automaticPublication.getMasterDataMasive().then(
        resp => {
          const data = resp.data || [];
          commit(SET_MASTERDATA_MASIVE, data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [PUBLISH_OFFERS_MASIVE]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      automaticPublication.publisOffersMasive(data).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [GET_PUBLICATION_DETAIL]: ({ commit }, publicationId) =>
    new Promise((resolve, reject) => {
      automaticPublication.getPublicationDetail(publicationId).then(
        resp => {
          const data = resp.data || [];
          commit(SET_PUBLICATION_DETAIL, data);
          resolve();
        },
        () => {
          reject();
        }
      );
    }),

  [GET_IMAGES_VEHICLE_ID]: (_, vehicleId) =>
    new Promise((resolve, reject) => {
      automaticPublication.getImagesVehicleId(vehicleId).then(
        resp => {
          const data = resp.data || {};
          resolve(data);
        },
        () => {
          reject();
        }
      );
    })
};
